<form [formGroup]="fieldAssignmentEditForm">
  <div class="form-row row">
    <div class="form-group col-md-6">
      <label for="sourceName"
             class="control-label">
        {{'i18n.domain.export-configuration.configurations.forms.file.field-configuration.form-fields.source' | translate}}
      </label>
      <ejs-dropdownlist id="sourceName"
                        [dataSource]="sourceFields"
                        [showClearButton]="true"
                        formControlName="sourceName">
      </ejs-dropdownlist>
      <app-error-messages [control]="fieldAssignmentEditForm.get('sourceName')"></app-error-messages>
    </div>
    <div class="form-group col-md-6">
      <label for="targetName"
             class="control-label">
        {{'i18n.domain.export-configuration.configurations.forms.file.field-configuration.form-fields.target' | translate}}
      </label>
      <input id="targetName"
             type="text"
             class="form-control"
             formControlName="targetName"/>
      <app-error-messages [control]="fieldAssignmentEditForm.get('targetName')"></app-error-messages>
    </div>
  </div>
  <div class="form-row row">
    @if (isExportZeroValueAsEmptyVisible) {
      <div class="form-group col-md-6">
        <label for="exportZeroValueAsEmpty" class="control-label">
          {{'i18n.domain.export-configuration.configurations.forms.file.field-configuration.form-fields.non-zero-values' | translate}}
        </label>
        <app-yes-no-group-button id="exportZeroValueAsEmpty" formControlName="exportZeroValueAsEmpty"></app-yes-no-group-button>
      </div>
    }
    @if (selectedSource?.canHaveCurrency) {
      <div class="form-group col-md-6">
        <label for="overwriteCurrency" class="control-label">
          {{'i18n.domain.export-configuration.configurations.forms.file.field-configuration.form-fields.currency' | translate}}
        </label>
        <app-enum-drop-down-list formControlName="overwriteCurrency"
                                 [showClearButton]="false"
                                 [enumType]="Currency"
                                 baseTranslationString='i18n.shared.currencies.'>
        </app-enum-drop-down-list>
        <app-error-messages [control]="fieldAssignmentEditForm.get('overwriteCurrency')"></app-error-messages>
      </div>
    }
    @if (isFixValueVisible) {
      <div class="form-group col-md-6">
        <label for="fixValue" class="control-label">
          {{'i18n.domain.export-configuration.configurations.forms.file.field-configuration.form-fields.static-value' | translate}}
        </label>
        <input id="fixValue"
               type="text"
               class="form-control"
               formControlName="fixValue"/>
        <app-error-messages [control]="fieldAssignmentEditForm.get('fixValue')"></app-error-messages>
      </div>
    }
    @if (selectedSource?.canHaveCap) {
      <div class="form-group col-md-6">
        <label for="cap" class="control-label">
          {{'i18n.domain.export-configuration.configurations.forms.file.field-configuration.form-fields.cap-from' | translate}}
        </label>
        <ejs-numerictextbox id="cap"
                            format="n0"
                            min="0"
                            formControlName="cap">
        </ejs-numerictextbox>
        <app-error-messages [control]="fieldAssignmentEditForm.get('cap')"></app-error-messages>
      </div>
    }
    @if (isCustomField1Visible) {
      <div class="form-group col-md-6">
        <label for="customField1Value" class="control-label" [ngClass]="{'required': selectedSource?.customField1Optional === false}">
          {{getCustomFieldLabel(selectedSource?.customField1Label)}}
        </label>
        <input id="customField1Value"
               type="text"
               class="form-control"
               formControlName="customField1Value"/>
        <app-error-messages [control]="fieldAssignmentEditForm.get('customField1Value')"></app-error-messages>
      </div>
    }
    @if (isCustomField2Visible) {
      <div class="form-group col-md-6">
        <label for="customField2Value" class="control-label required">
          {{getCustomFieldLabel(selectedSource?.customField2Label)}}
        </label>
        <input id="customField2Value"
               type="text"
               class="form-control"
               formControlName="customField2Value"/>
        <app-error-messages [control]="fieldAssignmentEditForm.get('customField2Value')"></app-error-messages>
      </div>
    }
    @if (isCustomField3Visible) {
      <div class="form-group col-md-6">
        <label for="customField3Value" class="control-label required">
          {{getCustomFieldLabel(selectedSource?.customField3Label)}}
        </label>
        <input id="customField3Value"
               type="text"
               class="form-control"
               formControlName="customField3Value"/>
        <app-error-messages [control]="fieldAssignmentEditForm.get('customField3Value')"></app-error-messages>
      </div>
    }
    @if (isCustomField4Visible) {
      <div class="form-group col-md-6">
        <label for="customField4Value" class="control-label required">
          {{getCustomFieldLabel(selectedSource?.customField4Label)}}
        </label>
        <input id="customField4Value"
               type="text"
               class="form-control"
               formControlName="customField4Value"/>
        <app-error-messages [control]="fieldAssignmentEditForm.get('customField4Value')"></app-error-messages>
      </div>
    }
    @if (isCustomField5Visible) {
      <div class="form-group col-md-6">
        <label for="customField5Value" class="control-label required">
          {{getCustomFieldLabel(selectedSource?.customField5Label)}}
        </label>
        <input id="customField5Value"
               type="text"
               class="form-control"
               formControlName="customField5Value"/>
        <app-error-messages [control]="fieldAssignmentEditForm.get('customField5Value')"></app-error-messages>
      </div>
    }
  </div>
  <div class="form-row row">
    <div class="col-12 mb-2">
      <app-error-messages [control]="fieldAssignmentEditForm" [asFreeText]="true"></app-error-messages>
    </div>
  </div>
</form>
